import React, { useMemo, useState } from "react";
import { File, FileType } from "../../types/api/get-file-with-siblings-success-response";
import { FileCard } from "../file-card/file-card";
import './file-list.css';
import { ArrowLeftOutlined } from "@ant-design/icons";
import { CMSButton } from "../../../../components/cms/button/cms-button.";

export type FileListType = 'fileChooser' | 'fileViewer';

type FileListProps = {
    files: File[];
    type?: FileListType;
    hasParentFolder: boolean;
    onDelete?: (id: number) => void;
    onFolderOpen?: (id: number) => void;
    onSelect?: (id: number) => void;
    onGoBackByOneFolder?: () => void;
    onFolderRename?: (id: number, name: string) => void;
    onFileMove?: (id: number) => void;
};

export const FileList = ({
    type = 'fileViewer',
    files,
    onDelete,
    onFolderOpen,
    onSelect,
    onGoBackByOneFolder,
    onFolderRename,
    hasParentFolder,
    onFileMove
}: FileListProps) => {
    const folders = useMemo(() => files?.filter(file => file.type === FileType.Directory), [files]);
    const _files = useMemo(() => files?.filter(file => (file.type === FileType.SimpleFile || file.type === FileType.ModelFile)), [files]);

    const [fileToBeMoved, setFileToBeMoved] = useState<File | null>(null);

    const handleGoBackByOneFolder: React.MouseEventHandler<HTMLSpanElement> = (e) => {
        e.stopPropagation();
        if (onGoBackByOneFolder) onGoBackByOneFolder();
    }

    return (
        <div className="file-list">
            {
                type === 'fileViewer' && fileToBeMoved && (
                    <div className="text-center mb-2">
                        Áthelyezendő fájl: { fileToBeMoved.name }
                        &nbsp;
                        <span
                            className='cursor-pointer'
                            style={{ color: 'red' }}
                            onClick={() => setFileToBeMoved(null)}
                        >Mégse</span>
                        <br />
                        <CMSButton
                            text="Áthelyezés a megnyitott mappába"
                            type="white"
                            onClick={
                                () => {
                                    if (onFileMove) {
                                        onFileMove(fileToBeMoved.id);
                                        setFileToBeMoved(null);
                                    }
                                }
                            }
                        />
                    </div>
                )
            }
            {
                hasParentFolder && (
                    <div className="mb-3">
                        <span className="cursor-pointer" onClick={handleGoBackByOneFolder}>
                            <ArrowLeftOutlined />
                            &nbsp;Vissza
                        </span>
                    </div>
                )
            }
            <div>Mappák</div>
            <div className="folders">
                {
                    folders.map(folder => (
                        <FileCard
                            file={folder}
                            key={folder.id}
                            cardType={type}
                            onFolderOpen={onFolderOpen}
                            onDelete={onDelete}
                            onFolderRename={(name) => { if (onFolderRename) onFolderRename(folder.id, name); }}
                        />
                    ))
                }
            </div>
            <div>Fájlok</div>
            <div className="files">
                {
                    _files.map(file => (
                        <FileCard
                            file={file}
                            key={file.id}
                            cardType={type}
                            onDelete={onDelete}
                            onSelect={onSelect}
                            onFileMove={() => setFileToBeMoved(file)}
                        />
                    ))
                }
            </div>
        </div>
    );
};